import { z } from 'zod';

const UPPERCASE_REGEX = /[A-Z]/;
const LOWERCASE_REGEX = /[a-z]/;
const SPECIAL_CHAR_REGEX = /[!@#$%^&*(),.?":{}|<>]/;

const PASSWORD_LENGTH_MIN = 8;
export const isPasswordTooShort = (password: string) =>
  password.length < PASSWORD_LENGTH_MIN;

export const validateCurrentPassword = (password: string): string => {
  if (!password) {
    return 'auth:signUp.errors.emptyPassword';
  } else if (isPasswordTooShort(password)) {
    return 'auth:signUp.errors.passwordMinLength';
  }

  return '';
};

export const passwordSchema = z
  .string()
  .min(1, { message: 'auth:signUp.errors.emptyPassword' })
  .min(8, { message: 'auth:signUp.errors.passwordMinLength' })
  .max(255, { message: 'auth:signUp.errors.passwordMaxLength' })
  .regex(UPPERCASE_REGEX, { message: 'auth:signUp.errors.uppercase' })
  .regex(LOWERCASE_REGEX, { message: 'auth:signUp.errors.lowercase' })
  .regex(SPECIAL_CHAR_REGEX, {
    message: 'auth:signUp.errors.specialCharacter',
  });

export const arePasswordsEqual = (password1: string, password2: string) =>
  password1 === password2;

export const validatePassword = (password: string): string => {
  const result = passwordSchema.safeParse(password);

  if (!result.success) {
    return result.error.issues[0]?.message ?? '';
  }

  return '';
};

export const validateNewPassword = (newPassword: string, oldPassword: string) =>
  validatePassword(newPassword) ||
  (arePasswordsEqual(newPassword, oldPassword)
    ? 'auth:resetPassword.passwordsShouldNotMatch'
    : '');

export const validateConfirmPassword = (
  confirmPassword: string,
  newPassword: string
) => {
  if (!newPassword) {
    return '';
  }

  return !arePasswordsEqual(confirmPassword, newPassword)
    ? 'auth:resetPassword.passwordsShouldMatch'
    : '';
};
